import axiosInstance from "@/api/axios-instance";

export interface SendPushInput {
  user_id: string;
  title: string;
  body: string;
  type: string;
  path: string;
  notification_id?: string;
  /** Optional: send directly to a OneSignal subscription id (testing/fallback). */
  subscription_id?: string;
}

export async function sendPushNotification(input: SendPushInput) {
  const response = await axiosInstance.post("/notifications/send-push", input);

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to send push notification");
  }

  return response.data;
}
